import React from 'react'

export const OurProducts = () => {
  return (
    <div>OurProducts</div>
  )
}
